import type { CapacityAlternativeOut } from '@/api/types';

/**
 * What a create returns once and never again: the capacity alternatives when
 * its start found no GPU. The launch page hands it to the deployment page it
 * navigates to. A create carries no API key: the first one is created on the
 * deployment page once it has run (#466).
 *
 * Memory only, for the same reasons as the launcher's `createdLaunch`: not the
 * URL, not router state (kept across reloads), not web storage, not the query
 * cache. One entry at most; the page forgets it as soon as it has read it.
 */
export type ManagedLaunchSecrets = {
  alternatives: CapacityAlternativeOut[];
};

let pending: { deploymentId: string; secrets: ManagedLaunchSecrets } | null = null;

export function handOverManagedLaunch(deploymentId: string, secrets: ManagedLaunchSecrets): void {
  pending = { deploymentId, secrets };
}

/** No side effect, so it is safe in a state initialiser. */
export function peekManagedLaunch(deploymentId: string): ManagedLaunchSecrets | null {
  return pending?.deploymentId === deploymentId ? pending.secrets : null;
}

export function forgetManagedLaunch(deploymentId: string): void {
  if (pending?.deploymentId === deploymentId) pending = null;
}

/** Called whenever the session ends, so nothing of a launch outlives it in
 *  this tab. */
export function clearManagedLaunch(): void {
  pending = null;
}
